import styled from "styled-components";

export const Row = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
}));

export const Badge = styled("span")(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "4px 10px",
  borderRadius: 6,
  border: "1px solid #f3d29a",
  background: "#fff7e8",
  color: "#7a4f00",
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.3,
  cursor: "default",

  "& .cashback-coin": {
    flexShrink: 0,
    fontSize: 18,
    color: "#f5a623",
  },
}));
